module.exports = __webpack_public_path__ + "static/media/contactPic.1c0fc1a2.jpg";